import { render, staticRenderFns } from "./AvatarModal.vue?vue&type=template&id=65a3c227&scoped=true"
import script from "./AvatarModal.vue?vue&type=script&lang=js"
export * from "./AvatarModal.vue?vue&type=script&lang=js"
import style0 from "./AvatarModal.vue?vue&type=style&index=0&id=65a3c227&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a3c227",
  null
  
)

export default component.exports